import { isUserLoggedIn } from "./helper";
import {
  DEFAULT_MUSIC_LENGTH_MS,
  UNAUTH_DEFAULT_DURATION_MS,
} from "../constants";

/** Resolves API music length: unauth uses default length; logged-in uses dropdown or default. */
export function resolveMusicGenerationDurationMs(
  durationMs: number | undefined,
  isLoggedIn = isUserLoggedIn(),
): number {
  if (!isLoggedIn) {
    return UNAUTH_DEFAULT_DURATION_MS;
  }
  if (durationMs !== undefined && durationMs > 0) {
    return durationMs;
  }
  return DEFAULT_MUSIC_LENGTH_MS;
}

/** e.g. "30-second", "1-minute", "90-second" (non-whole minutes stay in seconds). */
export function formatDurationLabelForPrompt(durationMs: number): string {
  const totalSeconds = Math.max(1, Math.round(durationMs / 1000));
  if (totalSeconds >= 60 && totalSeconds % 60 === 0) {
    return `${totalSeconds / 60}-minute`;
  }
  return `${totalSeconds}-second`;
}

/** Wraps editor keywords for the music generation API without changing the UI prompt. */
export function buildWrappedMusicPrompt(
  editorPrompt: string,
  durationMs: number,
): string {
  const trimmed = editorPrompt.trim();
  if (!trimmed) {
    return trimmed;
  }
  const durationLabel = formatDurationLabelForPrompt(durationMs);
  return `create a ${durationLabel} song of ${trimmed}`;
}

/** Guests get duration-prefixed prompt; logged-in users send the editor prompt as-is. */
export function buildApiMusicPrompt(
  editorPrompt: string,
  durationMs: number,
  isLoggedIn = isUserLoggedIn(),
): string {
  const trimmed = editorPrompt.trim();
  if (!trimmed) {
    return trimmed;
  }
  if (isLoggedIn) {
    return trimmed;
  }
  return buildWrappedMusicPrompt(trimmed, durationMs);
}
